import "./App.css";
import "./styles/theme.css";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext";
import { UserProvider } from "./contexts/UserContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/login/";
import SearchPage from "./pages/search";
import AlumMapPage from "./pages/alum-map";
import MyProfile from "./pages/my-profile";
import AboutPage from "./pages/about";
import AddUserPage from "./pages/admin/add-user";
import ModifyUsersPage from "./pages/admin/modify-users";
import NullCoordinatesPage from "./pages/admin/null-coordinates";

const App = () => {
  return (
    <ThemeProvider>
      <UserProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route 
              path="/search" 
              element={
                <ProtectedRoute>
                  <SearchPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-profile" 
              element={
                <ProtectedRoute>
                  <MyProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/alum-map" 
              element={
                <ProtectedRoute>
                  <AlumMapPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/about" 
              element={
                <ProtectedRoute>
                  <AboutPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/add-user" 
              element={
                <ProtectedRoute adminRequired={true}>
                  <AddUserPage />
                </ProtectedRoute>
              } 
            />
                        <Route 
              path="/admin/modify-users"
              element={
                <ProtectedRoute adminRequired={true}>
                  <ModifyUsersPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/null-coordinates"
              element={
                <ProtectedRoute adminRequired={true}>
                  <NullCoordinatesPage />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </Router>
      </UserProvider>
    </ThemeProvider>
  );
};

export default App;
